<section class="first-sec">
  <h2 class="head">Margin</h2>

  <div class="margin-select-wrap">
    <label for="" class="labels">Select Type</label>
    <select class="my-select-gold" (change)="goldSelect($event)">
      <option value="" disabled selected>Select</option>
      <option value="Gold">Gold Margin</option>
      <option value="Silver">Silver Margin</option>
    </select>
  </div>

  <!-- Gold Margin Section -->
  <div class="margin-card" *ngIf="isGold">
    <div class="margin-row">
      <span class="margin-label">Total Margin</span>
      <span class="margin-value">{{ margin?.total ?? 0 }}</span>
    </div>
    <div class="margin-row">
      <span class="margin-label">Used Margin</span>
      <span class="margin-value">{{ margin?.distributed ?? 0 }}</span>
    </div>
    <div class="margin-row">
      <span class="margin-label">Available Margin</span>
      <span class="margin-value highlight">{{ margin?.available ?? 0 }}</span>
    </div>
    <div class="margin-row">
      <span class="margin-label">Fixed Margin</span>
      <span class="margin-value">{{ margin?.fixed ?? 0 }}</span>
    </div>
    <div class="margin-row">
      <span class="margin-label">Credit Margin</span>
      <span class="margin-value">{{ margin?.credit ?? 0 }}</span>
    </div>
    <div class="margin-row">
      <span class="margin-label">Free Margin</span>
      <span class="margin-value">{{ margin?.free ?? 0 }}</span>
    </div>
  </div>

  <!-- Silver Margin Section -->
  <div class="margin-card" *ngIf="!isGold">
    <div class="margin-row">
      <span class="margin-label">Total Margin</span>
      <span class="margin-value">{{ margin?.silver_total ?? 0 }}</span>
    </div>
    <div class="margin-row">
      <span class="margin-label">Used Margin</span>
      <span class="margin-value">{{ margin?.silver_distributed ?? 0 }}</span>
    </div>
    <div class="margin-row">
      <span class="margin-label">Available Margin</span>
      <span class="margin-value highlight">{{ margin?.silver_available ?? 0 }}</span>
    </div>
    <div class="margin-row">
      <span class="margin-label">Fixed Margin</span>
      <span class="margin-value">{{ margin?.silver_fixed ?? 0 }}</span>
    </div>
    <div class="margin-row">
      <span class="margin-label">Credit Margin</span>
      <span class="margin-value">{{ margin?.silver_credit ?? 0 }}</span>
    </div>
    <div class="margin-row">
      <span class="margin-label">Free Margin</span>
      <span class="margin-value">{{ margin?.silver_free ?? 0 }}</span>
    </div>
  </div>
</section>